export default __webpack_public_path__ + "static/media/deviceMob.a1b4f011.png";